export function validateFile(file, extension) {
  let fileExtension = file.split(".").pop();
  if (extension.includes(fileExtension)) {
    return [true];
  } else {
    return [false, "Accepts only " + extension.join() + " file type"];
  }
}
